/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Link as GatsbyLink } from 'gatsby'

import styled from '@emotion/styled'
import Body from '../Body/Body'

export const StyledLink = styled(Body)`
  cursor: pointer;
`

export const checkForHtmlLink = link =>
  link.startsWith('https') ||
  link.startsWith('sms') ||
  link.startsWith('tel') ||
  link.startsWith('email')

const Link = ({ children, to, newRoute, linkProps, ...props }) => {
  if (to && checkForHtmlLink(to)) {
    return (
      <a href={to} {...linkProps}>
        <StyledLink {...props}> {children} </StyledLink>
      </a>
    )
  }
  if (!to) {
    return (
      <a {...linkProps}>
        <StyledLink {...props}> {children} </StyledLink>
      </a>
    )
  }

  return (
    <GatsbyLink to={to.startsWith('/') ? to : `/${to}`} {...linkProps}>
      <StyledLink {...props}> {children} </StyledLink>
    </GatsbyLink>
  )
}

export default Link
